import * as Sentry from '@sentry/react';

export const initSentry = () => {
  Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: 'https://01722a0aa17b40c5857332e411a59d29@o4508098541322240.ingest.de.sentry.io/4508222943264848',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        mask: ['[data-sentry-mask]'],
        blockSelector: 'iframe',
      }),
    ],
    normalizeDepth: 10,
    sampleRate: 1,
    tracesSampleRate: 0.2,
    // Tracing
    tracePropagationTargets: [],
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};

